
const g:any = window[ENV.projectName] = window[ENV.projectName] || {};

import { Component, Vue } from 'vue-property-decorator';

import { mainStore } from '../_store/main';

import MainGL from '../_modules/webgl/MainGL';
import PageComponent from '../_modules/PageComponent';
import { PointCloudDefinition } from '../_modules/webgl/PointCloud';


export default class Main extends PageComponent {
  protected mainGL!: MainGL<PointCloudDefinition>;

  constructor() {
    super();
    this.init();
  }

  protected async initMainGL() {
    const mainGLEl = this.bodyElm.querySelector('.js-mainGL') as HTMLElement;

    this.mainGL = new MainGL(
      mainGLEl,
      mainGLEl.querySelector('canvas') as HTMLCanvasElement,
      null,
      ''
    );

    await this.mainGL.init()
    .catch((e)=> {
      console.log(e);
      this.htmlElm.classList.add('is-noWebGL');
      mainStore.setNoWebGL(true);
    })
    this.mainGL.onResize();
  }

  protected async initContents(): Promise<void> {
    await Promise.all([
      super.initContents(),
      this.initMainGL()
    ]);
  }

  protected async init(): Promise<void> {
    mainStore.setCurrentPageId('privacy');
    await super.init();
    this.isLocked = false;
    this.play();
  }

  protected async onResize() {
    this.mainGL.onResize();
  }

  protected onScroll(): void {

  }

  public play(): void {
    this.mainGL.startLoop();
    this.mainGL.play();
    super.play();
  }
}